import React from 'react';
import { ReactComponent } from 'Common/components/Icons/protective-clothing.svg';

const ProtectiveClothing = () => <ReactComponent className="MuiSvgIcon-root" />;

export default ProtectiveClothing;
